import {useEffect, useState} from "react";

import {DashboardIncidentPopupDataType} from "~/data/dashboard/incident/use-dashboard-incident-popup.interface";
import {httpRequest} from "~/fetch/common/http-request";
import {getCookieValue} from "~/utills/get-cookie";

const useDashboardIncidentPopup = () => {
    const [response, setResponse] = useState<Array<DashboardIncidentPopupDataType[]>>([]);
    const [loading, setLoading] = useState<boolean>(false);

    function groupByBoardId(data: DashboardIncidentPopupDataType[]): DashboardIncidentPopupDataType[][] {
        const grouped = new Map<number, DashboardIncidentPopupDataType[]>();

        data.forEach((item) => {
            if (!grouped.has(item.boardId)) {
                grouped.set(item.boardId, []);
            }
            grouped.get(item.boardId)!.push(item);
        });

        return Array.from(grouped.values());
    }

    const request = async () => {
        setLoading(true);
        return await httpRequest<null, {list: DashboardIncidentPopupDataType[]}>({
            method: "GET",
            url: "/incidentBoard/list/active",
        })
            .submit()
            .then((res) => {
                if (res.data.list) {
                    const cookies = res.data.list.map((item) => {
                        const cookie = getCookieValue("incidentPopup_" + item.boardId);
                        if (cookie) return item.boardId;
                    });
                    const uniqueArr = cookies.filter((item, index) => cookies.indexOf(item) === index);
                    setResponse(groupByBoardId(res.data.list.filter((item) => !uniqueArr.includes(item.boardId))));
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        request();
    }, []);

    return {incidentPopupData: response};
};

export {useDashboardIncidentPopup};
